<!-- 購入枚数 -->
<template>
  <div class="row">
    <!-- 購入枚数 -->
    <label class="name">{{ $t("common.passengers") }} </label>

    <!-- bookGroup.divisions_labelを表示 -->
    <div class="value">
      {{ label }}
    </div>
  </div>
</template>

<script>
export default {
  name: "BgDivisionCount",
  props: {
    label: {
      type: String,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.row {
  display: flex;
  flex-direction: row;
  margin-bottom: 20px;
  font-size: 14px;
}

.row label {
  width: 110px;
  color: #888888;
}

.row .value {
  width: calc(100% - 110px);
  font-weight: bold;
  color: black;
}
</style>
